export type CookieConsent = {
  essential: boolean
  analytics: boolean
  marketing: boolean
  timestamp: string
}

export function getConsent(): CookieConsent | null {
  try {
    const raw = localStorage.getItem('cookie-consent')
    return raw ? JSON.parse(raw) : null
  } catch {
    return null
  }
}

export function setConsent(consent: CookieConsent) {
  localStorage.setItem('cookie-consent', JSON.stringify(consent))
  window.dispatchEvent(new CustomEvent('cookie-consent-changed', { detail: consent }))
}

export function hasAnalyticsConsent(): boolean {
  const c = getConsent()
  return c?.analytics === true
}

export function hasMarketingConsent(): boolean {
  const c = getConsent()
  return c?.marketing === true
}
